export const checkoutResponse = {
  type: "object",
  properties: {
    url: { type: "string" },
  },
  required: ["url"],
  additionalProperties: true,
};
